/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from "react";
import { useSelector } from "react-redux";

import { PageContainer } from "../components/layout/PageContainer";
import YesNoAction from "../components/YesNoAction";
import { selectCurrentFarmerAccount } from "../features/azure-b2c/storage";
import { TestIds } from "../testIds";
import { URLS } from "../util/consts";

export function NoAccess() {
  const currentAccount = useSelector(selectCurrentFarmerAccount);

  const openFindOutMore = () => {
    window.open(URLS.findOutMore, "_blank");
  };

  const openSignUpNow = () => {
    window.open(URLS.signUpNow, "_blank");
  };
  const hasShareholderAccess = currentAccount?.hasShareholderAccess;

  return (
    <PageContainer
      data-testid={
        hasShareholderAccess
          ? TestIds.pages.mixedAccessShareholderAccess
          : TestIds.pages.noShareHolderAccess
      }
    >
      <YesNoAction
        display="Kia Ora,"
        subheading="Welcome to FarmlandsPRO"
        body={
          hasShareholderAccess ? (
            <span>
              <span>Account: {currentAccount?.accountName}</span>
              <br />
              <span>Account number: {currentAccount?.accountNumber}</span>
              <br />
              <br />
              This account is not a Farmlands shareholder account. If you have other accounts with
              Farmlands you can switch using the account selector.
              <br />
              <br />
              If you’d like to find out more information or sign up to become a shareholder, please
              following the links below.
            </span>
          ) : (
            "FarmlandsPRO is a platform for Farmlands shareholders. If you’d like to find out more information or sign up to become a shareholder, please follow the links below."
          )
        }
        optionA={{
          label: "Find out more",
          onClick: openFindOutMore,
        }}
        optionB={{
          label: "Sign up now",
          onClick: openSignUpNow,
        }}
      />
    </PageContainer>
  );
}
export default NoAccess;
